import styled, { css } from 'styled-components';

import {
    Flex,
    Radio,
    token,
} from '@zillow/constellation';

export const StyledFlexContainer = styled(Flex)`
    border: 1px solid ${token('colors.gray300')};
    box-sizing: border-box;
    border-radius: 4px;
    cursor: pointer;
    height: 100%;

    &:hover {
        background: ${token('colors.blue100')};
        border: 1px solid ${token('colors.blue400')};

        ${Radio} {
            border-color: ${token('colors.brand')}
        }
    }

    ${props => props.active && css`
        background: ${token('colors.blue100')};
        border: 1px solid ${token('colors.blue400')};
    `};
`;
